import axios from '../axios'

/* 
 * 用户管理
 */
//查询用户列表
export const getList = (params) => {
  return axios({
      url: '/user/list',
      method: 'get',
      params
  })
}
//查询管理员列表
export const getAdminList = (params) => {
  return axios({
      url: '/user/admin/list',
      method: 'get',
      params
  })
}
// 新增管理员
export const addAdminApi = data => {
    return axios({
        url: '/user/admin',
        method: 'post',
        data
    })
}
//更新
export const updateAdminApi = data => {
  return axios({
      url: '/user/admin',
      method: 'put',
      data
  })
}
//查详情
export const detailAdminApi= (id) => {
  return axios({
      url: `/user/admin/${id}`,
      method: 'get',
      // params
  })
}
//删除
export const deleteApi= (id) => {
  return axios({
      url: `/user/admin/${id}`,
      method: 'delete',
      // params
  })
}
//重置密码
export const resetPasswordApi = data => {
  return axios({
      url: '/user/admin/password',
      method: 'put',
      data
  })
}
//修改会员有效期
export const updateRemmberDateApi = data => {
  return axios({
      url: '/user/vip',
      method: 'put',
      data
  })
}
//查询用户刷题记录
export const getExamRecordList = (params) => {
  return axios({
      url: '/user/exam/record',
      method: 'get',
      params
  })
}


// WEBPACK FOOTER //
// ./src/http/api/user.js